<div class="container">
    <div class="row d-flex flex-wrap">

        <div class="col-12 col-sm-12 col-md-3">
            <h2 class="orange-header">QR Codes</h2>
            <p>Generate unlimited QR codes for fixed or variable amounts</p><br>

            <h3>Use This When:</h3>
            <ul>
                <li>you have customers who prefer to scan-to-pay</li>
            </ul>

            <h3>
                What you need to do:</h3>
            <ul>
                <li>create the QR code</li>
                <li>download your QR code to add to your own point-of-sale material
                </li>
                <li>download and print our handy template</li>
            </ul>
        </div>

        <div class="col-12 col-sm-12 col-md-9 justify-content-center align-self-center">
            <img [ngSrc]="'walkthrough-qr.gif' | assetSource"
                 alt="quick pay image"
                 class="walkthrough-image responsive-gif"
                 height="1"
                 width="1"/>
        </div>
    </div>
</div>